<template>
    <section class="dispatchOrder-table">
        <div v-loading="loading">
            <div class="dispatch-table-header">
                <el-button
                    type="text"
                    class="dispatch-refresh"
                    icon="el-icon-refresh"
                    @click="handleRefresh"
                >
                    刷新
                </el-button>
            </div>
            <table-box
                ref="tablePage"
                :columns="config.table.columns"
                :height="config.table.height"
                :loading="loading"
                :rows="tableData"
                :actions="config.table.action"
                @action-click="actionClick"
            >
            </table-box>
            <m-page
                :current-page="currentPage"
                :pageData="config.page"
                :total="pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
                class="page-container"
            ></m-page>
        </div>
        <!-- 按运单装车页面 -->
        <dispatch-waybill-loading
            v-if="showDispatchWaybillLoading"
            :componentsModalData="componentsModalData"
            @components-close="handleRefresh()"
        ></dispatch-waybill-loading>
        <!-- 按运单装车页面 -->
        <!-- 运单明细装车 -->
        <dispatch-waybill-details-loading
            v-if="showDispatchWaybillDetailsLoading"
            :componentsModalData="componentsModalData"
            @components-close="handleRefresh()"
        ></dispatch-waybill-details-loading>
        <!-- 运单明细装车 -->
    </section>
</template>
<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import { dictWithUrl } from '@/components/lots/api.js';
import DispatchWaybillLoading from '../../components/dispatchWaybillLoading/Index';
import DispatchWaybillDetailsLoading from '../../components/dispatchWaybillDetailsLoading/Index';
import { queryLoadCarTransportPage } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { formatTotalDataList, isValidateLoading } from './util';
import config from './config.js';

export default {
    name: 'dispatchDetailedLoadingTable',
    components: { tableBox, mPage, DispatchWaybillLoading, DispatchWaybillDetailsLoading },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            componentsModalData: [], // 表格选中数据
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            dictionaryCode: [
                'TRANSPORT_STATUS', // 运单状态
                'PICK_UP_TYPE' // 到车登记方式
            ],
            dictData: {}, // 数据字典集合
            pageTotal: 0,
            currentPage: 1,
            componentsName: '',
            showDispatchWaybillLoading: false, // 是否显示按运单装车确认
            showDispatchWaybillDetailsLoading: false // 是否显示运单明细装车
        };
    },
    mounted () {
        this.getList();
    },
    methods: {
        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            const dict = await dictWithUrl(this.dictionaryCode.join(','));
            this.dictData = dict.data;
            const obj = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                param: {
                    dispatchNo: this.componentsData.dispatchNo
                }
            };
            this.loading = true;
            queryLoadCarTransportPage(obj).then((res) => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(e => {
                        e.dispatchStatus = this.componentsData.dispatchStatus;
                    });
                    this.tableData = formatTotalDataList(res.data.list, this.dictData);
                    this.page.pageNo = res.data.pageNo;
                    this.page.pageSize = res.data.pageSize;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.showDispatchWaybillLoading = false;
            this.showDispatchWaybillDetailsLoading = false;
            this.page = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            };
            this.getList();
        },
        /**
         * @description 操作列事件处理
         * @event {事件类型} waybillDetailedLoading 运单明细装车
         * @row   {Object} 行数据
        */
        async actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'waybillDetailedLoading':
                    this.showDispatchWaybillDetailsLoading = true;
                    this.componentsModalData = row;
                    break;
                case 'waybillLoading':
                    const isOk = await isValidateLoading({ taskNo: row.taskNo });
                    if (!isOk) return;
                    this.showDispatchWaybillLoading = true;
                    this.componentsModalData = row;
                    break;
                default:
                    break;
            }
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                ...data,
                pageNo: 1
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        }

    }
};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
.confirmClass {
    width: 600px;
}
</style>
